import { Outlet } from "react-router-dom";

function ManagementInstruments() {
  return <Outlet />;
}

export default ManagementInstruments;
